import { HekateEventBus } from 'www-shared';

const hekateBus: HekateEventBus = window.hekateEventBus;

export default hekateBus;
